import styled from "styled-components";
import { JourneyBackground } from "./JourneyBackground";
import { JourneyIntroduction } from "./JourneyIntroduction";
import { JourneyCompanyAtGlance } from "./JourneyCompanyAtGlance";
import { RATypography, RAImage } from "@/components/customs";
import { Row, Col, Grid } from "antd";
import { JourneyCommitment } from "./JourneyCommitment";
import { CareerProgram, AvailablePositions, JoinOurTeam } from "./CareerProgram";
import { MainFooter } from "../../Footer/MainFooter";
import { useEffect, useState } from "react";

import ReactFullpage from "@fullpage/react-fullpage";
import { JourneyMilestone } from "./JourneyMilestone";
import { useHeaderSolid } from "@/hooks/HeaderSolidContext";
const { useBreakpoint } = Grid;
const FULL_PAGE_API_KEY = process.env.NEXT_PUBLIC_FULL_PAGE_API_KEY;

export function ComponentJourneyNormal({ pageContent = {} }) {
	const { headerSolid } = useHeaderSolid();

	const { content = {} } = pageContent;
	const { a_brief_history_of_royal_air } = content;
	const [activeSlide, setActiveSlide] = useState(0);
	const [theme, setTheme] = useState("transparent");
	const screens = useBreakpoint();
	const [scrollDirection, setScrollDirection] = useState(null);
	const onLeave = (origin, destination, direction) => {
		setActiveSlide(destination.index);
		headerSolid(destination.index);
		setScrollDirection(direction);
		// arguments are mapped in order of fullpage.js callback arguments do something
		// with the event
	};

	useEffect(() => {
		return () => {
			fullpage_api.silentMoveTo(1);
		};
	}, []);

	return (
		<>
			{/* <Menu /> */}
			<div
				id="fixed-timeline-backgrounds"
				style={{
					width: "100%",
					height: "100%",
					position: "absolute",
					opacity: activeSlide >= 1 && activeSlide <= a_brief_history_of_royal_air?.timelines?.length ? 1 : 0,
					transition: "all 0.6s linear",
					top: 0,
					left: 0,
					zIndex:
						activeSlide >= 1 && activeSlide <= a_brief_history_of_royal_air?.timelines?.length ? -2 : -3,
					background: "#fff",
				}}
			>
				{a_brief_history_of_royal_air?.timelines?.map((timeline, index) => {
					return (
						<div
							className="section"
							key={`timeline-image-${index}`}
							style={{
								height: "100%",
								width: "100%",
								position: "absolute",
								transition: "1s all linear",
								opacity: activeSlide === index + 1 ? 1 : 0,
							}}
						>
							<RAImage
								url={
									screens.md ? timeline?.desktop_background_photo : timeline?.mobile_background_photo
								}
								width="100%"
								height="100vh"
							/>
						</div>
					);
				})}
			</div>
			<div
				id="fixed-milestones"
				style={{
					width: "100%",
					height: "100%",
					position: "absolute",
					opacity: activeSlide >= 1 && activeSlide <= a_brief_history_of_royal_air?.timelines?.length ? 1 : 0,
					transition: "all 0.6s linear",
					top: 0,
					left: 0,
					zIndex:
						activeSlide >= 1 && activeSlide <= a_brief_history_of_royal_air?.timelines?.length ? -1 : -2,
					background: "transparent",
				}}
			>
				<JourneyMilestone
					historyContent={a_brief_history_of_royal_air}
					active={activeSlide - 1}
					scrollDirection={scrollDirection}
				/>
			</div>
			<ReactFullpage
				licenseKey={FULL_PAGE_API_KEY}
				onLeave={onLeave}
				scrollingSpeed={1100}
				fadingEffect={true}
				normalScrollElements=".ant-picker-panel-container, .ant-modal, #snap-disabled, .ant-picker-time-panel-column, .mapboxgl-canvas, .ant-modal-wrap, .ra-search-airport-ant-select-dropdown"
				credits={{ enabled: false }}
				lazyLoading={false}
				onScrollOverflow={(section, slide, position, direction) => {
					if (position === 0) {
						setTheme("transparent");
					} else {
						if (theme !== "white") {
							setTheme("white");
						}
					}
				}}
				render={({ state, fullpageApi }) => {
					return (
						<ReactFullpage.Wrapper>
							<EachSlide className="section fp-auto-height" id="hero-section">
								<JourneyBackground banner={content?.banner} />
								<EachSlide>
									<BodyContainer>
										<JourneyIntroduction
											introducing_you_to_royal_air={content?.introducing_you_to_royal_air}
										/>
									</BodyContainer>
								</EachSlide>
								<EachSlide>
									<div style={{ width: "100vw" }}>
										<JourneyCompanyAtGlance
											our_company_at_a_glance={content?.our_company_at_a_glance}
										/>
									</div>
								</EachSlide>
							</EachSlide>
							{a_brief_history_of_royal_air?.timelines?.map((timeline, index) => {
								return <div className="section" key={`timeline-${index}`}></div>;
							})}
							<EachSlide className="section fp-auto-height">
								<LayoutOverlay style={{ paddingTop: 84 }}>
									<JourneyCommitment commitment_to_excellence={content?.commitment_to_excellence} />
								</LayoutOverlay>
								<EachSlide>
									<BodyTravelCardContainer style={{ paddingTop: 120 }}>
										<JoinOurTeam joining_our_team={content?.joining_our_team} />
									</BodyTravelCardContainer>
								</EachSlide>
								<EachSlide style={{ paddingBottom: 60 }}>
									<BodyTravelCardContainer style={{ paddingTop: 30 }}>
										<AvailablePositions available_positions={content?.available_positions} />
									</BodyTravelCardContainer>
								</EachSlide>
								<EachSlide id="footer-section">
									<footer
										style={{
											width: "100%",
											paddingBottom: 84,
										}}
									>
										<MainFooter />
									</footer>
								</EachSlide>
							</EachSlide>
						</ReactFullpage.Wrapper>
					);
				}}
			/>
		</>
	);
}

const EachSlide = styled.div`
	width: 100vw;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const BodyContainer = styled.div`
	max-width: 1442px;
	padding: 84px 136px;
	width: 100%;
	@media (max-width: 991px) {
		padding: 90px 80px 0px 80px;
	}
	@media (max-width: 767px) {
		padding: 60px 32px 00px 32px;
	}
	@media (max-width: 575px) {
		padding: 40px 20px 20px 20px;
	}
`;

const LayoutOverlay = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	background-image: url("/images/journey/Journey-BG-Web.png");
	background-repeat: no-repeat;
	background-size: cover;
	@media (max-width: 768px) {
		background-image: url("/images/journey/Journey-BG-Mobile.png");
	}
`;
const BGImage = styled.img`
	object-fit: fill;
	width: 100%;
	height: 100%;
	position: absolute;
	z-index: -1;
`;

const BodyTravelCardContainer = styled.div`
	max-width: 1442px;
	padding: 84px 136px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	@media (max-width: 991px) {
		padding: 84px 80px;
	}
	@media (max-width: 767px) {
		padding: 60px 32px;
	}
	@media (max-width: 575px) {
		padding: 20px;
	}
`;
